module.exports = __webpack_public_path__ + "img/logo-vendor.433db429.png";